export const songOptions = [
  {
    id: "20",
    label: "Levitating - Dua Lipa",
  },
  {
    id: "19",
    label: "Shape of You - Ed Sheeran",
  },
  {
    id: "18",
    label: "Do I Wanna Know - Arctic Monkeys",
  },
  {
    id: "17",
    label: "Sucker - Jonas Brothers",
  },
  {
    id: "16",
    label: "Sk8er Boi - Avril Lavigne",
  },
  {
    id: "15",
    label: "Someone Like You - Adele",
  },
  {
    id: "14",
    label: "Highway to Hell - AC/DC",
  },
  {
    id: "13",
    label: "Blinding Lights - The Weeknd",
  },
  {
    id: "12",
    label: "Somebody That I Used to Know - Gotye",
  },
  {
    id: "11",
    label: "Lose Yourself - Eminem",
  },
  {
    id: "10",
    label: "Eye of the Tiger - Survivor",
  },
  {
    id: "9",
    label: "Zombie - The Cranberries",
  },
  {
    id: "8",
    label: "All Star - Smash Mouth",
  },
  {
    id: "7",
    label: "Toxic - Britney Spears",
  },
  {
    id: "6",
    label: "Wonderwall - Oasis",
  },
  {
    id: "5",
    label: "Bad Guy - Billie Eilish",
  },
  {
    id: "4",
    label: "Smooth Criminal - Michael Jackson",
  },
  {
    id: "3",
    label: "Bohemian Rhapsody - Queen",
  },
  {
    id: "2",
    label: "I write sins not tragedies - Panic! At The Disco",
  },
  {
    id: "1",
    label: "Poker Face - Lady Gaga",
  },
  {
    id: "01",
    label: "Billie Jean - Michael Jackson",
  },
  {
    id: "02",
    label: "Stairway to Heaven - Led Zeppelin",
  },
  {
    id: "03",
    label: "Hotel California - Eagles",
  },
  {
    id: "05",
    label: "Like a Rolling Stone - Bob Dylan",
  },
  {
    id: "06",
    label: "Smells Like Teen Spirit - Nirvana",
  },
  {
    id: "07",
    label: "Imagine - John Lennon",
  },
  {
    id: "08",
    label: "Hey Jude - The Beatles",
  },
  {
    id: "09",
    label: "Sweet Child o' Mine - Guns N' Roses",
  },
  {
    id: "010",
    label: "Uptown Funk - Mark Ronson ft. Bruno Mars",
  },
  {
    id: "011",
    label: "Rolling in the Deep - Adele",
  },
  {
    id: "013",
    label: "Thriller - Michael Jackson",
  },
  {
    id: "014",
    label: "Superstition - Stevie Wonder",
  },
  {
    id: "015",
    label: "Yesterday - The Beatles",
  },
  {
    id: "016",
    label: "Born to Run - Bruce Springsteen",
  },
  {
    id: "017",
    label: "I Will Always Love You - Whitney Houston",
  },
  {
    id: "018",
    label: "Every Breath You Take - The Police",
  },
  {
    id: "019",
    label: "Take On Me - A-ha",
  },
  {
    id: "020",
    label: "Don't Stop Believin' - Journey",
  },
  {
    id: "021",
    label: "We Will Rock You - Queen",
  },
  {
    id: "023",
    label: "Livin' on a Prayer - Bon Jovi",
  },
  {
    id: "024",
    label: "Nothing Else Matters - Metallica",
  },
  {
    id: "025",
    label: "Purple Rain - Prince",
  },
  {
    id: "026",
    label: "Riptide - Vance Joy",
  },
  {
    id: "027",
    label: "Dancing Queen - ABBA",
  },
  {
    id: "028",
    label: "Let It Be - The Beatles",
  },
  {
    id: "029",
    label: "Piano Man - Billy Joel",
  },
  {
    id: "030",
    label: "Creep - Radiohead",
  },
  {
    id: "031",
    label: "My Heart Will Go On - Celine Dion",
  },
  {
    id: "033",
    label: "I Want to Hold Your Hand - The Beatles",
  },
  {
    id: "034",
    label: "The Sound of Silence - Simon & Garfunkel",
  },
  {
    id: "035",
    label: "Seven Nation Army - The White Stripes",
  },
  {
    id: "036",
    label: "We Are the Champions - Queen",
  },
  {
    id: "039",
    label: "Back in Black - AC/DC",
  },
  {
    id: "040",
    label: "Take Me Home, Country Roads - John Denver",
  },
  {
    id: "041",
    label: "We Didn't Start the Fire - Billy Joel",
  },
  {
    id: "043",
    label: "Chasing Cars - Snow Patrol",
  },
  {
    id: "045",
    label: "Shake It Off - Taylor Swift",
  },
  {
    id: "046",
    label: "Gangnam Style - PSY",
  },
  {
    id: "047",
    label: "Call Me Maybe - Carly Rae Jepsen",
  },
  {
    id: "048",
    label: "Hotline Bling - Drake",
  },
  {
    id: "049",
    label: "Despacito - Luis Fonsi ft. Daddy Yankee",
  },
  {
    id: "051",
    label: "God's Plan - Drake",
  },
  {
    id: "052",
    label: "Old Town Road - Lil Nas X",
  },
  {
    id: "054",
    label: "Closer - The Chainsmokers ft. Halsey",
  },
  {
    id: "055",
    label: "Radioactive - Imagine Dragons",
  },
  {
    id: "056",
    label: "Counting Stars - OneRepublic",
  },
  {
    id: "057",
    label: "Wake Me Up - Avicii",
  },
  {
    id: "058",
    label: "Havana - Camila Cabello",
  },
  {
    id: "059",
    label: "Royals - Lorde",
  },
  {
    id: "061",
    label: "Shape of My Heart - Backstreet Boys",
  },
  {
    id: "062",
    label: "Tears in Heaven - Eric Clapton",
  },
  {
    id: "063",
    label: "Killing Me Softly - Fugees",
  },
  {
    id: "064",
    label: "Roses - SAINt JHN",
  },
  {
    id: "065",
    label: "Can't Stop the Feeling! - Justin Timberlake",
  },
  {
    id: "066",
    label: "Sunflower - Post Malone",
  },
  {
    id: "068",
    label: "Memories - Maroon 5",
  },
  {
    id: "069",
    label: "Perfect - Ed Sheeran",
  },
  {
    id: "070",
    label: "Thinking Out Loud - Ed Sheeran",
  },
  {
    id: "071",
    label: "Photograph - Ed Sheeran",
  },
  {
    id: "072",
    label: "Roar - Katy Perry",
  },
  {
    id: "073",
    label: "Firework - Katy Perry",
  },
  {
    id: "075",
    label: "Halo - Beyoncé",
  },
  {
    id: "076",
    label: "If I Ain't Got You - Alicia Keys",
  },
  {
    id: "077",
    label: "Stay - Rihanna ft. Mikky Ekko",
  },
  {
    id: "078",
    label: "Cheap Thrills - Sia",
  },
  {
    id: "079",
    label: "Lean On - Major Lazer",
  },
  {
    id: "080",
    label: "Rather Be - Clean Bandit",
  },
  {
    id: "081",
    label: "Viva La Vida - Coldplay",
  },
  {
    id: "082",
    label: "Fix You - Coldplay",
  },
  {
    id: "083",
    label: "Yellow - Coldplay",
  },
  {
    id: "084",
    label: "Boulevard of Broken Dreams - Green Day",
  },
  {
    id: "085",
    label: "American Idiot - Green Day",
  },
  {
    id: "087",
    label: "Smash Into You - Beyoncé",
  },
  {
    id: "088",
    label: "Apologize - OneRepublic",
  },
  {
    id: "089",
    label: "Don't Let Me Down - The Chainsmokers",
  },
];
